import { Flex } from 'antd';
import { CRX_SUPPORT_EMAIL } from 'app/config';
import { Link, Subtitle, Title } from 'components/mvp-typography';
import { getFirstName } from 'lib/utils/string/normalise';
import { PropsWithChildren } from 'react';
import { PatientInfoState } from '../_utils/patient-info/patient-info-slice-types';

export function PatientHomeLayout(
  props: PropsWithChildren<{ patientInfo: PatientInfoState }>
) {
  const firstName = getFirstName(props.patientInfo.patient.displayName ?? '');
  // const nextAssessment =
  //   props.patientInfo.assessmentOverview?.nextAssessmentType;

  return (
    <Flex
      style={{ height: '100%', justifyContent: 'center', textAlign: 'center' }}
    >
      <Flex
        style={{ width: '60%', alignItems: 'center', paddingTop: '20px' }}
        gap={60}
        vertical
      >
        <div>
          <Title text={`Let's get started, ${firstName}!`} color={'#230056'} />
          {/* <Title level={3}>Next assessment: {nextAssessment}</Title> */}
        </div>
        {props.children}
        <div>
          <Subtitle
            style={{ padding: '100px 0px 10px 0px' }}
            className="crx-typography button-big"
            color={'#A366FC'}
          >
            For assistance, please contact your provider, or contact us at{' '}
            <Link href={`mailto:${CRX_SUPPORT_EMAIL}`}>
              {CRX_SUPPORT_EMAIL}
            </Link>{' '}
          </Subtitle>
        </div>
      </Flex>
    </Flex>
  );
}
